import React from 'react'
import { Table, DataTable, Chip, Icon } from '@arnsbogroup/react-voicearchive'
import AddMembers from './components/AddMembers'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import messages from './messages'

const AgencyMembers = ( {agency, onChange = () => {}, refetch = () => {}} ) => {
  if (!agency) {
    return null
  }
  const { formatMessage } = useIntl()
  const agencyHead = agency.headSupplier.uid
  const Span = ({ children }) => <span>{ children }</span>
  const getStatusChip = ( status ) => (
    <Chip size="sm" state={{
      'BLOCKED': 'error',
      'INACTIVE': 'error',
      'ACTIVE': 'success',
      'APPLICANT': 'warning',
      'ONLINE': 'success',
      'IN REVIEW': 'warning',
      'ACCEPTED': 'warning',
      'ONBOARDING': 'warning',
      'REJECTED': 'error',
    }[status.toUpperCase()] ?? undefined}>
      <span className="capitalize">
        { status ? status.toLowerCase() : '' }
      </span>
    </Chip>
  )

  const onDelete = (entry) => {
    if (confirm(formatMessage(messages.onDeleteConfirm, { display_name: entry.display_name }))) {
      onChange({
        ...agency,
        members: agency.members.filter((el) => { return el.uid != entry.uid })
      })
    }
  }
  
  const onAgencyHeadChange = (entry) => {
    if (confirm(formatMessage(messages.onHeadChangeConfirm, { display_name: entry.display_name }))) {
      onChange({
        ...agency,
        newHeadOfAgency: entry
      })
    }
  }

  const onAgencyHeadRatesDuplicate = (entry) => {
    if (entry?.uid && confirm(formatMessage(messages.onDuplicateAgencyHeadRatesConfirm, { display_name: entry.display_name }))) {
      fetch(`/rest/v2/supplier/${entry.uid}/rates/duplicate`, {
        method: 'POST',
        body: JSON.stringify({
          fromSupplierId: agencyHead
        })
      })
      .then(response => response.json())
      .then((response) => {
        if (response.success) {
          refetch(agency.uid)
        } else {
          toastr.error(response.errors.join(','))
        }
      }).catch((error) => {
        window.alert(`${error}`);
      })
    }
  }

  const Actions = (entry) => {
    return (
      <div className='flex flex-col-2 space-x-2'>
        <span
          title={formatMessage(messages.deleteMemberTitle)}
          className={agencyHead == entry.uid ? 'cursor-not-allowed' : 'cursor-pointer'}
          onClick={(event) => {
            event.stopPropagation()
            agencyHead == entry.uid ?
            undefined :
            onDelete(entry);
          }}
        >
          <Icon className={agencyHead == entry.uid ? 'text-gray-300' : 'text-negative'} icon={['fas', 'trash']} />
        </span>
        <span
          title={formatMessage(messages.changeAgencyHeadTitle)}
          className={agencyHead == entry.uid ? 'cursor-not-allowed' : 'cursor-pointer'}
          onClick={(event) => {
            event.stopPropagation()
            agencyHead == entry.uid ?
            undefined :
            onAgencyHeadChange(entry)
          }}
        >
          <Icon className={agencyHead == entry.uid ? 'text-warning' : 'text-gray-300'} icon={['fas', 'crown']} />
        </span>
        <span
          title={formatMessage(messages.duplicateAgencyHeadRates)}
          className={`fa-layers fa-fw ${agencyHead == entry.uid ? 'cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={(event) => {
            event.stopPropagation()
            agencyHead == entry.uid ?
            undefined :
            onAgencyHeadRatesDuplicate(entry)
          }}
        >
          <span className='fa-layers fa-fw'>
            <Icon icon={['fas', 'dollar-sign']} transform="shrink-2" className={agencyHead == entry.uid ? 'text-gray-300' : 'text-primary'}/>
            <Icon icon={['fas', 'copy']} transform="right-8 up-8 shrink-6" className={agencyHead == entry.uid ? 'text-gray-300' : 'text-positive'} />
          </span>
        </span>
      </div>
    )
  }

  return (
    <div className='mt-2'>
      <AddMembers agency={agency} onChange={onChange} />
      <DataTable
        components={{
          Tr: ({ childProps = {}, ...innerProps }) => {
            return (
              <Table.Tr onClick={childProps.uid ? () => window.open(`/suppliers/${childProps.uid}/overview`, '_blank') : undefined}
                {...innerProps }
              />
            )
          },
          Td: ({ childProps = {}, ...props }) => (
            <Table.Td
              {...props }
            />
          )
        }}
        head={{
          userid: { label: 'User ID' },
          email: { label: 'Email' },
          rates_duplication_status: { label: 'Rates duplication status' },
          status: { label: 'Supplier status' },
          actions: { label: 'Actions' }
        }}
        body={{
          userid: Span,
          email: Span,
          rates_duplication_status: (entry) => (
            <div>
              <Chip size="sm" state={{
                'FULL': 'info',
                'SOME': 'warning',
                'NONE': null,
              }[entry.rates_duplication_status] ?? undefined}>
                <span>
                  {{
                    'FULL': formatMessage(messages.ratesFullDuplicated,
                      {
                        duplicated_at: entry.rates_duplicated_at
                          ? <><FormattedDate value={entry.rates_duplicated_at} /> <FormattedTime value={entry.rates_duplicated_at} /></>
                          : null
                      }),
                    'SOME': formatMessage(messages.ratesSomeDuplicated,
                      {
                        duplicated_at: entry.rates_duplicated_at
                          ? <><FormattedDate value={entry.rates_duplicated_at} /> <FormattedTime value={entry.rates_duplicated_at} /></>
                          : null
                      }),
                    'NONE': formatMessage(messages.ratesNoneDuplicated),
                  }[entry.rates_duplication_status] ?? undefined }
                </span>
              </Chip>
            </div>
          ),
          status: (entry) => (
            getStatusChip(entry.status.name)
          ),
          actions: (entry) => (
            Actions(entry)
          )
        }}
        entries={Array.isArray(agency?.members) ? agency?.members : []}
      />
    </div>
  )
}

export default AgencyMembers